export default "__VITE_ASSET__6c58bc68__"